import CompareChartTabs from './CompareChartTabs';

const CompareAnalysisSection = () => {
  return <CompareChartTabs />;
};
export default CompareAnalysisSection;
